"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerCancellationReasonWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@ferry/journey-services");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var operators_1 = require("rxjs/operators");
var ButtonLink_1 = require("../components/ButtonLink");
var react_select_1 = require("react-select");
var FalconOptimizedOption_1 = require("../components/FalconOptimizedOption");
var ExtendedFalconDynamicOptimizedMenuList_1 = require("../components/ExtendedFalconDynamicOptimizedMenuList");
var portal_core_1 = require("@ferry/portal-core");
var CustomerCancellationReasonWidget = /** @class */ (function (_super) {
    __extends(CustomerCancellationReasonWidget, _super);
    function CustomerCancellationReasonWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.NEXT_BUTTON_ELEMENT_ID = "navigatorNext";
        _this.handleBetterPremiumValue = function (event) {
            var _a;
            var betterPremiumValue = event.target.value;
            _this.setState({ betterPremiumValueAnnualMotor: betterPremiumValue });
            _this.cancellationReason = (_a = _this.cancellationReason) !== null && _a !== void 0 ? _a : {};
            _this.cancellationReason.betterPremiumValue = betterPremiumValue;
            _this.props.onStateChange("cancellationReasonInfo", _this.cancellationReason);
            _this.executeEvent("change");
        };
        _this.incrementLoadingQueueSize = function (callback) {
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize + 1
            }); }, callback);
        };
        _this.decrementLoadingQueueSize = function (callback) {
            if (_this.state.loadingQueueSize === 0) {
                return;
            }
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize - 1
            }); }, callback);
        };
        _this.setNextButtonDisability = function (nextButtonElement, state) {
            if (nextButtonElement) {
                nextButtonElement.disabled = state;
            }
        };
        _this.getNextButtonElement = function () {
            return document.getElementById(_this.NEXT_BUTTON_ELEMENT_ID);
        };
        _this.handleCancellationReason = function (event) {
            var state = event.target.name;
            _this.setState({
                cancellationReason: state,
                reasonSelected: true
            });
            var customerCancellationReason = {};
            customerCancellationReason.cancellationReasonCode = event.target.name;
            customerCancellationReason.type = "CUSTOMER";
            customerCancellationReason.product = _this.props.product;
            if (_this.props.interaction.uistate.includedProducts === 3) {
                var cancellationReasons = [];
                if (_this.props.interaction.cancellationReasons) {
                    cancellationReasons = _this.props.interaction.cancellationReasons
                        .filter(function (cancellationReason) { return cancellationReason.product !== _this.props.product; });
                }
                cancellationReasons.push(customerCancellationReason);
                _this.props.onStateChange("cancellationReasons", cancellationReasons);
            }
            else {
                _this.props.onStateChange("cancellationReasonInfo", customerCancellationReason);
            }
            _this.cancellationReason = customerCancellationReason;
            _this.executeEvent("change");
        };
        _this.state = {
            betterPremiumInsurerIdAnnualMotor: -1,
            betterPremiumValueAnnualMotor: -1,
            cancellationReason: undefined,
            cancellationReasonDescription: undefined,
            reasonSelected: false,
            loadingQueueSize: 0,
            lookupValues: [],
        };
        _this.handleCancellationReasonDescription = _this.handleCancellationReasonDescription.bind(_this);
        _this.handleOnClickEvent = _this.handleOnClickEvent.bind(_this);
        return _this;
    }
    CustomerCancellationReasonWidget.prototype.componentDidMount = function () {
        var _this = this;
        var _a;
        this.getCancellationReasons(this.props.interaction.product);
        if ((_a = this.props.interaction.cancellationReasonInfo) === null || _a === void 0 ? void 0 : _a.cancellationReasonCode) {
            var cancellationReasonInfo = this.props.interaction.cancellationReasonInfo;
            this.setState({
                cancellationReason: cancellationReasonInfo.cancellationReasonCode,
                cancellationReasonDescription: cancellationReasonInfo.details,
                reasonSelected: true
            });
        }
        if (!this.state.cancellationReason) {
            var nextButtonElement = this.getNextButtonElement();
            // Disabling next button initially
            this.setNextButtonDisability(nextButtonElement, true);
        }
        this.incrementLoadingQueueSize(function () {
            _this.lookupService.fetchLookupValues("ClsInsurers", "en-UK")
                .pipe((0, operators_1.finalize)(function () { return _this.decrementLoadingQueueSize(); }))
                .subscribe(function (lookupValues) {
                _this.setState({
                    lookupValues: lookupValues.map(function (lookupValue) {
                        return { value: lookupValue.id, label: lookupValue.value };
                    })
                });
            });
        });
    };
    CustomerCancellationReasonWidget.prototype.componentWillUnmount = function () {
        var nextButtonElement = this.getNextButtonElement();
        this.setNextButtonDisability(nextButtonElement, false);
    };
    CustomerCancellationReasonWidget.prototype.getCancellationReasons = function (product) {
        var _this = this;
        this.incrementLoadingQueueSize(function () {
            _this.falconConvenienceApiService.getCustomerCancellationReasons(product)
                .pipe((0, operators_1.finalize)(function () { return _this.decrementLoadingQueueSize(); }))
                .subscribe(function (output) {
                _this.cancellationReasons = output;
            });
        });
    };
    // Is handled this way only for annual product as for other products validation is attached to different button,
    // and nextPageId property is not null
    CustomerCancellationReasonWidget.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var prevCancellationReason = prevState.cancellationReason;
        var cancellationReason = this.state.cancellationReason;
        if (!prevCancellationReason && prevCancellationReason !== cancellationReason) {
            var nextButtonElement = this.getNextButtonElement();
            this.setNextButtonDisability(nextButtonElement, false);
        }
    };
    CustomerCancellationReasonWidget.prototype.render = function () {
        var _a;
        if (!((_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.uistate)) {
            return null; // or return a loading state or an error message
        }
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.loadingQueueSize > 0 }), this.renderCancellationReasons(), this.getSetting("nextPageId") && (0, jsx_runtime_1.jsx)("button", { className: "mb-0 btn btn-primary btn-next", id: "".concat(this.props.question.name), onClick: this.navigateNext, disabled: this.state.reasonSelected, children: "Next" })] }));
    };
    CustomerCancellationReasonWidget.prototype.renderCancellationReasons = function () {
        if (this.cancellationReasons) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "panel cancellation-reason-widget", children: [(0, jsx_runtime_1.jsx)("img", { className: "mr-2 car-cancellation-reason-icon", alt: "car-icon", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/wolf-car-icon.png") }), (0, jsx_runtime_1.jsx)("div", { className: "pt-3 pb-2 cancellation-reason-question", children: "Please tell us why you want to cancel your car policy?" }), (0, jsx_runtime_1.jsx)("fieldset", { className: "d-block input-group margin-top-14 w-100", role: "group", children: this.renderCancellationReasonsOptions(this.props.product, this.cancellationReasons) }, this.props.product)] }));
        }
    };
    CustomerCancellationReasonWidget.prototype.renderCancellationReasonsOptions = function (product, cancellationReasons) {
        var _this = this;
        var reasons = [];
        cancellationReasons.forEach(function (reason) {
            var hasReason = _this.state.reasonSelected && _this.state.cancellationReason === reason.cancellationReasonCode;
            reasons.push((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "custom-control margin-bottom-20-padding-left-0", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-radiobutton cursor-pointer", type: "radio", name: reason.cancellationReasonCode, id: "".concat(product, "-option-").concat(reason.cancellationReasonCode, "_").concat(product), value: reason.cancellationReasonText, onChange: _this.handleCancellationReason, checked: _this.state.cancellationReason === reason.cancellationReasonCode }), (0, jsx_runtime_1.jsx)("label", { id: "".concat(product, "-option-").concat(reason.cancellationReasonCode, "-label"), className: "checkbox-label driver-label border-0", htmlFor: "".concat(product, "-option-").concat(reason.cancellationReasonCode, "_").concat(product), children: reason.cancellationReasonText })] }, product + "-" + reason.cancellationReasonCode), (hasReason && (_this.state.cancellationReason === journey_services_1.POOR_SERVICE_KEY || _this.state.cancellationReason === journey_services_1.OTHER_KEY ||
                        _this.state.cancellationReason === journey_services_1.ALLIANZ_CANT_INSURE_ME_KEY)) &&
                        _this.renderComment(reason.cancellationReasonText, reason.cancellationReasonCode, product), (hasReason && (_this.state.cancellationReason === journey_services_1.CHANGED_MY_CAR_KEY || _this.state.cancellationReason === journey_services_1.SOLD_MY_CAR_KEY)) &&
                        _this.renderChangeCar(), (hasReason && _this.state.cancellationReason === journey_services_1.TOO_EXPENSIVE_KEY) && _this.renderOtherInsurer()] }));
        });
        return reasons;
    };
    CustomerCancellationReasonWidget.prototype.renderChangeCar = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group changed-car-wrapper", children: [(0, jsx_runtime_1.jsx)("span", { children: "Did you know that you can replace your car without cancelling your policy." }), (0, jsx_runtime_1.jsx)("div", { className: "font-weight-bold", children: "Would you like a price to swap the insurance to your new car?" }), (0, jsx_runtime_1.jsx)(ButtonLink_1.ButtonLink, { id: "replace-car-1", "aria-label": "Replace car", primary: true, to: this.props.interaction.uistate.isCarReplaceDisabled ? "" : "/journey/init/product/AnnualMotorInsurance/process/mtaReplaceCar/preset/".concat(this.props.interaction._id), disabled: this.props.interaction.uistate.isCarReplaceDisabled, children: "Yes, replace my car" }), (0, jsx_runtime_1.jsx)("button", { id: "cancel-cover-button", type: "button", className: "btn btn-white btn-white-blue-border mb-0 w-100", onClick: this.handleOnClickEvent, children: "No, cancel cover" })] }));
    };
    CustomerCancellationReasonWidget.prototype.renderOtherInsurer = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group changed-car-wrapper", children: [(0, jsx_runtime_1.jsx)("label", { className: "font-light", htmlFor: "betterPremiumInsurerId", children: "Please tell us who is giving you a better price" }), (0, jsx_runtime_1.jsx)(react_select_1.default, { id: "betterPremiumInsurerId", className: "autocompleteNewInsurer ".concat(this.getSetting("cssClass", ""), " ").concat(this.getInputValidationClass()), classNamePrefix: "autocompleteNewInsurer", components: {
                        MenuList: ExtendedFalconDynamicOptimizedMenuList_1.default,
                        Option: FalconOptimizedOption_1.default,
                        DropdownIndicator: function () { return null; }
                    }, options: this.state.lookupValues, name: "betterPremiumInsurerId", onChange: function (e) { return _this.handleBetterPremiumInsurerId(e); }, "aria-label": "Please tell us who is giving you a better price", placeholder: "Type new insurer name", filterOption: (0, react_select_1.createFilter)({ ignoreAccents: false, matchFrom: 'start' }), isClearable: true, openMenuOnClick: false, openMenuOnFocus: false }), (0, jsx_runtime_1.jsx)("label", { className: "font-light", htmlFor: "betterPremiumValue", style: { marginTop: 20 }, children: "How much lower is the premium" }), (0, jsx_runtime_1.jsx)("input", { className: "form-control description-textarea", id: "betterPremiumValue", type: "number", name: "betterPremiumValue", maxLength: 300, onKeyDown: function (e) {
                        if (["-", "+"].includes(e.key)) {
                            e.preventDefault();
                        }
                    }, onPaste: function (e) {
                        var pasted = e.clipboardData.getData("text");
                        if (/[+-]/.test(pasted)) {
                            e.preventDefault();
                        }
                    }, onChange: function (e) { return _this.handleBetterPremiumValue(e); }, min: 0 }), (0, jsx_runtime_1.jsx)(portal_core_1.InfoBanner, { wording: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "We are sorry to see you go." }), (0, jsx_runtime_1.jsx)("br", {}), "Your current policy is for our Plus cover level. We now also offer Essentials - comprehensive car insurance that covers the basics. If you're interested, just ", (0, jsx_runtime_1.jsx)("a", { href: "/dashboard/getNewQuote", children: "get a new quote." })] }) })] }));
    };
    CustomerCancellationReasonWidget.prototype.getInputValidationClass = function () {
        var result = this.props.validations[this.props.question.name];
        if (!result) {
            return null;
        }
        if (result.valid) {
            if (this.getSetting("validFeedback")) {
                return "is-valid";
            }
        }
        else {
            return "is-invalid";
        }
        return null;
    };
    CustomerCancellationReasonWidget.prototype.handleBetterPremiumInsurerId = function (event) {
        var _a;
        var selectedInsurerId;
        if (!event) {
            selectedInsurerId = 0;
        }
        else {
            selectedInsurerId = event.value;
        }
        this.setState({ betterPremiumInsurerIdAnnualMotor: selectedInsurerId });
        this.cancellationReason = (_a = this.cancellationReason) !== null && _a !== void 0 ? _a : {};
        this.cancellationReason.betterPremiumInsurerId = selectedInsurerId;
        this.props.onStateChange("cancellationReasonInfo", this.cancellationReason);
        this.executeEvent("change");
    };
    ;
    CustomerCancellationReasonWidget.prototype.handleOnClickEvent = function (event) {
        this.executeEvent('click');
        event.preventDefault();
    };
    CustomerCancellationReasonWidget.prototype.renderComment = function (description, reason, product) {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group cancellation-reason-description-wrapper pb-2", children: [(0, jsx_runtime_1.jsx)("label", { className: "font-light", htmlFor: "claimReasonDescription", children: "Please give us more details (optional)" }), (0, jsx_runtime_1.jsx)("textarea", { className: "form-control description-textarea", id: "cancellationReasonDescription", maxLength: 300, value: this.state.cancellationReasonDescription, onChange: function (e) { return _this.handleCancellationReasonDescription(e, reason, product); }, onClick: function (e) { return _this.handleCancellationReasonDescription(e, reason, product); } })] }));
    };
    CustomerCancellationReasonWidget.prototype.handleCancellationReasonDescription = function (event, productCode, product) {
        var state = event.target.value;
        this.setState({ cancellationReasonDescription: state });
        var cancellationReasonDescription = state;
        var customerCancellationReason = {};
        customerCancellationReason.type = "CUSTOMER";
        customerCancellationReason.product = product;
        customerCancellationReason.cancellationReasonCode = productCode;
        customerCancellationReason.details = cancellationReasonDescription;
        if (this.props.interaction.uistate.includedProducts === 3) {
            var cancellationReasons = this.props.interaction.cancellationReasons
                .filter(function (cancellationReason) { return cancellationReason.product !== product; });
            cancellationReasons.push(customerCancellationReason);
            this.props.onStateChange("cancellationReasons", cancellationReasons);
        }
        else {
            this.props.onStateChange("cancellationReasonInfo", customerCancellationReason);
        }
        this.executeEvent("change");
    };
    ;
    CustomerCancellationReasonWidget.prototype.navigateNext = function () {
        this.props.engine.navigate(this.getSetting("nextPageId"));
    };
    ;
    __decorate([
        (0, core_1.lazyInject)(journey_services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], CustomerCancellationReasonWidget.prototype, "falconConvenienceApiService", void 0);
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], CustomerCancellationReasonWidget.prototype, "lookupService", void 0);
    return CustomerCancellationReasonWidget;
}(plugin_journey_1.WidgetBase));
exports.CustomerCancellationReasonWidget = CustomerCancellationReasonWidget;
//# sourceMappingURL=CustomerCancellationReasonWidget.js.map